import api from './api';

export const subscriptionService = {
  // Obtener todas las inscripciones
  getSubscriptions: async (params = {}) => {
    const response = await api.get('/subscriptions', { params });
    return response.data;
  },

  // Obtener una inscripción específica
  getSubscription: async (id) => {
    const response = await api.get(`/subscriptions/${id}`);
    return response.data;
  },

  // Crear una nueva inscripción
  createSubscription: async (subscriptionData) => {
    const response = await api.post('/subscriptions', subscriptionData);
    return response.data;
  },

  // Actualizar una inscripción
  updateSubscription: async (id, subscriptionData) => {
    const response = await api.put(`/subscriptions/${id}`, subscriptionData);
    return response.data;
  },

  // Eliminar una inscripción
  deleteSubscription: async (id) => {
    const response = await api.delete(`/subscriptions/${id}`);
    return response.data;
  }
};
